import { _post } from "../../apiClient";
import { _showToast } from "../../toastHelper";

const uploadImage = async (imageType, file, eventCode, imageFrom) => {
    if (file) {
        let formData = new FormData();
        formData.append("ImageType", imageType);
        formData.append("EventCode", eventCode);
        formData.append("ImageFrom", imageFrom);
        formData.append("file", file);

        return await _post("/uploads/image", formData, { headers: { "Content-Type": "multipart/form-data" } })
            .then((response) => {
                return response.key;
            }).catch(error => {
                _showToast(error, "error");
                return "";
            });
    }
}

const deleteImages = async (keys) => {
    if (keys && keys.length > 0) {
        return await _post("/uploads/images/delete", keys)
            .then((response) => {
            }).catch(error => {
            });
    }
}

export { uploadImage, deleteImages };